import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getProducts({ commit }, data) {
      try {
        const response = await api.get(`/products`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
